import React from "react";
import DefaultModal from "../DefaultModal";
import { useTranslation } from "react-i18next";
import CusButton from "../../mui/custom_button/CusButton";

export default function ConfirmCloseModal({ isOpen, closeModal, onConfirm, currentGame }) {
  const { t } = useTranslation();

  console.log("currentGame", currentGame);

  return (
    <DefaultModal isOpen={isOpen} closeModal={closeModal} classModal="error-game-modal">
      <h2>{t("Close the game")}</h2>
      <div className="error-game-modal__content">
        <h3>{currentGame.name}</h3>
        <p>{t("Changes made may be lost")}</p>

        <div className="buttons">
          <CusButton text={"Back"} onClick={closeModal} />
          <CusButton color="gray" text={"Close"} onClick={onConfirm} />
        </div>
      </div>
    </DefaultModal>
  );
}
